import { NodeResultAbstract } from '@/utils/measurements/node-results/node-result.abstract';
import { NodeResult, ValueItem } from '@/services/api.types';

type MultiChoiceResultValue = {
  value: string;
};

export class MultiChoiceResultClass extends NodeResultAbstract {
  constructor(node: NodeResult) {
    super(node);
    this.jsonValue = node.result ? JSON.parse(node.result) : [];
  }

  getMeasurementType(): string {
    return this.node.multiple_choice_type ?? '';
  }

  getValue() {
    const found = this.getFirstValueChild<MultiChoiceResultValue>();
    return found?.value;
  }

  getValues(): number[] | string[] {
    const values = this.getAllValueChildren<MultiChoiceResultValue>();
    if (values) {
      return values.map(v => v.value);
    } else {
      return [];
    }
  }

  getMeasurementValues<MultiChoiceResultValue>(): Array<
    MultiChoiceResultValue & ValueItem
  > {
    const values = this.getAllValueChildren<MultiChoiceResultValue>();
    return values;
  }

  toString(): string {
    return this.getValue().toString();
  }
}
